module.exports = __webpack_public_path__ + "static/twitter-icon-314206a50d2a5cdfedb4e94c17984a8a.png";